import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  canonical?: string;
}

export const useSEO = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  canonical,
}: SEOProps) => {
  useEffect(() => {
    // Update title
    if (title) {
      document.title = title;
    }

    // Helper to update or create meta tag
    const updateMetaTag = (selector: string, attribute: string, content: string) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        if (selector.includes('property')) {
          element.setAttribute('property', selector.split('=')[1].replace(/['"]/g, ''));
        } else {
          element.setAttribute('name', selector.split('=')[1].replace(/['"]/g, ''));
        }
        document.head.appendChild(element);
      }
      element.setAttribute(attribute, content);
    };

    // Update meta tags
    if (description) {
      updateMetaTag('meta[name="description"]', 'content', description);
    }

    if (keywords) {
      updateMetaTag('meta[name="keywords"]', 'content', keywords);
    }

    // Open Graph
    if (ogTitle) {
      updateMetaTag('meta[property="og:title"]', 'content', ogTitle);
    }

    if (ogDescription) {
      updateMetaTag('meta[property="og:description"]', 'content', ogDescription);
    }

    if (ogImage) {
      updateMetaTag('meta[property="og:image"]', 'content', ogImage);
    }

    if (ogUrl) {
      updateMetaTag('meta[property="og:url"]', 'content', ogUrl);
    }

    // Twitter
    if (ogTitle) {
      updateMetaTag('meta[name="twitter:title"]', 'content', ogTitle);
    }

    if (ogDescription) {
      updateMetaTag('meta[name="twitter:description"]', 'content', ogDescription);
    }

    if (ogImage) {
      updateMetaTag('meta[name="twitter:image"]', 'content', ogImage);
    }

    // Canonical URL
    if (canonical) {
      let linkElement = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!linkElement) {
        linkElement = document.createElement('link');
        linkElement.setAttribute('rel', 'canonical');
        document.head.appendChild(linkElement);
      }
      linkElement.setAttribute('href', canonical);
    }

    // Cleanup function to restore defaults
    return () => {
      document.title = 'ALINA POLONEYEVA';
    };
  }, [title, description, keywords, ogTitle, ogDescription, ogImage, ogUrl, canonical]);
};
